import { Box, Table, Typography, useTheme } from "@mui/material";
import { tokens } from "../../global/theme/tokens";
import { useEffect, useState } from "react";
import { API_DELETE, API_GET, DBRequest, useConfig } from "../../api/api";
import CardGrid from "../../components/cards/layout/CardGrid";
import PictureNameCard from "../../components/cards/PictureNameCard";
import LocalizedStrings from "react-localization";
import CardContainer from "../../components/cards/layout/CardContainer";
import { CardContentText } from "../../components/cards/content/CardContentText";
import { CardContentMail } from "../../components/cards/content/CardContentMail";
import { CardContentLink } from "../../components/cards/content/CardContentLink";
import { CardContentPhone } from "../../components/cards/content/CardContentPhone";
import MoneyCard from "../../components/cards/MoneyCard";
import SkeletonCard from "../../components/cards/SkeletonCard";
import AddressCard from "../../components/cards/AddressCard";
import SpeedDialMenu from "../../components/menu/SpeedDialMenu";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useFetch from "../../api/useFetch";
import ExoDialog from "../../components/exo/ExoDialog";
import NewContact from "../../components/new/NewContact";
import { MultiContactCard } from "../../components/cards/MultiContactCard";
import PhoneIcon from "@mui/icons-material/Phone";
import { useTranslation } from "react-i18next";
import EmailIcon from "@mui/icons-material/Email";

const ExtendContact = ({ row, onUpdate, onDelete }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();
  const { t } = useTranslation();
  const { apiData, setApiData } = useFetch(`contacts/${row.id}`);

  // menu
  function handleDelete() {
    DBRequest({
      config,
      path: `contacts/${row.id}`,
      method: API_DELETE,
      onResponse: handleDeleteRow,
    });
  }

  const actions = [
    {
      icon: <ModeEditIcon />,
      name: t("Edit"),
      onClick: handleEdit,
    },
    { icon: <DeleteOutlineIcon />, name: t("Delete"), onClick: handleDelete },
  ];

  //edit contact
  const [open, setOpen] = useState(false);
  const [startData, setStartData] = useState(null);
  function handleEdit() {
    setStartData(apiData.data);
    setOpen(true);
  }

  function handleUpdate(data) {
    setApiData(data);
    onUpdate(data.data);
  }
  function handleDeleteRow() {
    onDelete(row);
  }

  return (
    <CardGrid>
      {!apiData ? (
        <ContactSkeleton />
      ) : (
        <>
          <SpeedDialMenu actions={actions} />
          <PictureNameCard
            span={1}
            name={`${apiData.data.salutation} ${apiData.data.firstName} ${apiData.data.lastName}`}
          />
          <CardContactData contact={apiData.data} />
          <MoneyCard title={t("Sales")} amount={apiData.data.salesTotal} />
          <MultiContactCard
            label={t("Phonenumbers")}
            contactArray={apiData.data.telephoneNumbers}
            nameKey="phoneType"
            valueKey="phoneNumber"
            Icon={PhoneIcon}
            linkPrefix="tel:"
          />
          <MultiContactCard
            label={t("E-Mailaddresses")}
            span={2}
            contactArray={apiData.data.emails}
            nameKey="emailType"
            valueKey="emailAddress"
            Icon={EmailIcon}
            linkPrefix="mailto:"
          />
          <AddressCard address={apiData.data.address} />
        </>
      )}
      <ExoDialog open={open} limitWidth>
        <NewContact
          fullWidth
          onClose={() => setOpen(false)}
          onUpdate={handleUpdate}
          startData={startData}
        />
      </ExoDialog>
    </CardGrid>
  );
};

const CardContactData = ({ contact }) => {
  const { t } = useTranslation();
  return (
    <CardContainer span={2}>
      <Table>
        <tbody>
          <tr>
            <td>
              <Typography variant="h6">{t("Nr")}</Typography>
            </td>
            <td>
              <CardContentText text={contact.nr} />
            </td>
          </tr>
          {contact.url && (
            <tr>
              <td>
                <Typography variant="h6">{t("Url")}</Typography>
              </td>
              <td>
                <CardContentLink href={contact.url} />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </CardContainer>
  );
};

const ContactSkeleton = () => {
  return (
    <>
      <SkeletonCard height={186} />
      <SkeletonCard height={186} span={2} />
      <SkeletonCard height={186} />
      <SkeletonCard height={104} />
    </>
  );
};

export default ExtendContact;
